import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { combineActions, handleActions } from 'redux-actions';
import { publishTier, updateTier, tierSaveError, tierSaveRedirect } from './actions';
const reducers = handleActions({
    [combineActions(publishTier, updateTier).toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            requestStatus: 'fetching',
            errorMessage: undefined
        }),
    [tierSaveError.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            requestStatus: 'error',
            errorMessage: action.payload.message
        }),
    [tierSaveRedirect.toString()]: (state, action)=>_object_spread_props(_object_spread({}, state), {
            requestStatus: 'redirecting'
        })
}, {
    requestStatus: 'idle'
});
export default reducers;
